import { toast } from "react-toastify";
import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { DepartmentResponse as DepartmentResponse, DepartmentsResponse } from "./DepartmentsTypes";
import { SpaceResponse } from "../Space/SpacesTypes";
const ENDPOINT_DEPARTMENTS = "departments";

const getDepartments = async (token: string) => {

  const departementsResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_DEPARTMENTS as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as DepartmentsResponse)
    // void toast.promise(departementsResult,
    // {
    //   pending: 'Searching Departments',
    //   error: 'Error please contact support 🤯'
    // });

  return departementsResult;
}

const getDepartmentById = (token: string, idDepartement: number) => {
  const endpoint = `${ENDPOINT_DEPARTMENTS}/${idDepartement}`;

  const departementResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as DepartmentResponse);
  // void toast.promise(articleResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });
  return departementResult;
};

// To have all lines of a specific service in quota table 

const getSpacesByDepartementId = (token: string, idDepartement: number) => {
  const endpoint = `${ENDPOINT_DEPARTMENTS}/${idDepartement}/space`;

  const departementsResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SpaceResponse[]);
  // void toast.promise(articleResult,
  //   {
  //     pending: 'Searching Articles',
  //     error: 'Error please contact support 🤯'
  //   });
  return departementsResult;
};

const deleteDepartment = async (token: string, id: number) => {

  const departmentResult = genericCoworkerCompanionAPICall(
    token,
    "DELETE",
    `${ENDPOINT_DEPARTMENTS}/${id}/delete`,
    ""
  )

  await toast.promise(
    departmentResult,
    {
      success: 'Department deleted',
      pending: 'Deleting Department',
      error: 'Contact support',
    });

};

const createDepartment = async (token: string, department: {name: string;}) => {
  
  const BODY = JSON.stringify({ 
    "Name": department.name,
  });

  const departmentResult = genericCoworkerCompanionAPICall(
    token,
    "POST",
    `${ENDPOINT_DEPARTMENTS}/addDepartments`,
    BODY
  )

  await toast.promise(
    departmentResult,
    {
      success: 'Department created',
      pending: 'Creating Department',
      error: 'Fail to create Department, please contact support or retry with correct informations',
    });
};

const updateDepartment = async (token: string, department: { id: number; name: string;}) => {
  const BODY = JSON.stringify({
    "Id": department.id,
    "Name": department.name,
  });

  const departmentResult = genericCoworkerCompanionAPICall(
    token,
    "PUT",
    `${ENDPOINT_DEPARTMENTS}/${department.id}`,
    BODY
  )

  await toast.promise(
    departmentResult,
    {
      success: 'Department edited',
      pending: 'Editing Department',
      error: 'Contact support',
    });

};

export { getDepartments, getDepartmentById, getSpacesByDepartementId,createDepartment, updateDepartment, deleteDepartment }


